import { axiosInstance } from '../../api';
const BASE_PATH = '/analytics';


//get overall source analytics
export let getOverallSourceAnalytics = async (starting_month, ending_month) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_source_analytics', {
            starting_month: starting_month,
            ending_month: ending_month
        })
        return value;
    } catch (error) {
        return error
    }
}

//get monthly trends
export let getSourceAnalyticsMonthlyTrend = async (starting_month, ending_month) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_source_analytics_monthly_trends', {
            starting_month: starting_month,
            ending_month: ending_month
        })
        return value;
    } catch (error) {
        return error
    }
}